import { memo, useEffect, useState } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const IDS_DIFERENCA_COR_MANCHA = [-1, -2, 11, 32];

export const RevisaoDefeitoEngomagem = memo(function RevisaoDefeitoEngomagem({ defeitos, month, setor }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        if (setor === 3) {
            let defeitosF = defeitos.filter((element) => { 
                return parseInt(element.mes) === month && element.cod_defeitotipo === setor && IDS_DIFERENCA_COR_MANCHA.includes(element.cod_defeito) 
            });

            let _data = [];

            const classificacoes = [2,3,4]
            classificacoes.forEach(item => {
                let nome = '';
                let total = 0;
                if(item === 2) {
                    let filter = defeitosF.filter((element) => { return [11,32].includes(element.cod_defeito) });
                    [11, 32].forEach((defeito) => {
                        total = 0;
                        let nome = '';
                        filter.forEach((item) => {
                            if(item.cod_defeito === defeito) {
                                total += parseFloat(item.soma);
                                nome = item.descricao;
                            }
                        });
                        _data.push({
                            "nome": `Classificação ${item} ${nome}`,
                            "total": parseInt(total)
                        });
                    });
                } else if(item === 3) {
                    let filter = defeitosF.filter((element) => { return element.cod_defeito === -1 });
                    filter.forEach((item) => {
                        nome = item.descricao;
                        total += parseFloat(item.soma);
                    });
                } else {
                    let filter = defeitosF.filter((element) => { return element.cod_defeito === -2 });
                    filter.forEach((item) => {
                        nome = item.descricao;
                        total += parseFloat(item.soma);
                    });
                }

                if(item !== 2) {
                    _data.push({
                        "nome": `Classificação ${item} ${nome}`,
                        "total": total
                    });
                }
                
            });

            setData(_data);
        }


    }, [defeitos, month, setor])

    if (setor !== 3 || defeitos.length === 0)
        return null;

    return (
        <div className='p-col-4'>
            <DataTable
                responsiveLayout='scroll'
                size='small'
                value={data}
            >
                <Column header="Descrição" field="nome" />
                <Column header="Total" field="total" />
            </DataTable>
        </div>
    )
});